<template>
  <div>
    <div class="d-flex justify-content-between mb-4 align-items-center">
      <div class="list-title">
        <div class="filter-title">All Staffs</div>
      </div>
      <div class="list-filter">
        <div class="search-filter">
          <button data-toggle="modal" data-target="#searchFilter" class="btn link-filter p-0">
            <img src="/images/filters.svg" alt="cog-icon" class="ml-1 mb-1 icon-filter" />
            Filters
          </button>

          <div class="modal fade" id="searchFilter" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
              <div class="modal-content p-2">
                <div class="modal-body">
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="modal-name">Filter employee or employee group</div>
                    <button
                      class="btn btn-cancel float-right"
                      data-dismiss="modal"
                      aria-label="Close"
                    >Cancel</button>
                  </div>
                  <div class="mb-2">
                    <input
                      placeholder="Search by name, title or email"
                      class="form-control"
                      type="text"
                      v-model="searchQuery"
                    />
                  </div>
                  <multiselect
                    :multiple="true"
                    :allowEmpty="true"
                    :options="userGroupOptions"
                    v-model="userGroupFilter"
                    :searchable="false"
                    :show-labels="false"
                    track-by="code"
                    label="label"
                  >
                    <span slot="caret" slot-scope="{ toggle }" class="arrow">
                        <img
                            src="/images/caret-down.svg"
                            alt="dropdown select"
                        />
                    </span>
                  </multiselect>
                  <div class="row mt-3">
                    <div class="col-6">
                      <button
                        class="btn btn-clear"
                        @click="resetFilter()"
                      >Clear filters</button>
                    </div>
                    <div class="col-6">
                      <button
                        class="btn btn-filter"
                        @click="applyFilter()"
                      >Filter</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-4 mt-2" v-if="mode=='list'">
      <div class="col-12">
        <admin-staff-item v-for="user of users" :key="user.id" :user="user"></admin-staff-item>

        <div class="row mb-4" v-if="!singleLoading && users.length == 0">
          <div class="col-12 text-center">
            No freelancers found
          </div>
        </div>

        <div v-if="singleLoading" class="d-block position-relative">
          <p class="d-flex">
            <span class="spinner-border mr-2" role="status">
              <span class="sr-only">Loading...</span>
            </span>
            Loading staffs data...
          </p>
        </div>

        <div class="row" v-if="hasMoreUsers()">
          <div class="col-12 col-sm-5 mx-auto">
            <button
                @click="fetchMoreStaffs()"
                type="button"
                class="wfh-btn-color-primary wfh-btn-large btn-block"
            >
              See More
            </button>
          </div>
        </div>
      </div>

      <div class="col-12" v-if="users.length == 0 && loading.length > 0">
        <div class="row mb-4">
            <div class="col-12 text-center">
              No freelancers with the filtered value found
            </div>
          </div>
      </div>
    </div>

    <div class="row mb-4 mt-2" v-if="mode=='department'">
      <div class="col-12">
        <div v-for="group in departments" :key="group.id" v-if="hasRelatedUsers(group)">
          <div class="d-flex justify-content-between mb-3">
            <h4>{{ group.name }}</h4>
            <div :class="{'currency-grid' : group.departmentCosts.length > 1,'mt-1':true}">
              <small class="currency-tag" v-for="cost in group.departmentCosts">{{ cost.total_cost }}</small>
            </div>
          </div>
          <admin-staff-item v-for="user of getRelatedMember(group)" :key="user.id" :user="user"></admin-staff-item>

          <div class="row mb-4" v-if="!loading[group.id] && users.length === 0">
            <div class="col-12 text-center">
              No freelancers found
            </div>
          </div>

          <div v-if="loading[group.id]" class="d-block position-relative">
            <p class="d-flex">
              <span class="spinner-border mr-2" role="status">
                <span class="sr-only">Loading...</span>
              </span>
              Loading staffs data...
            </p>
          </div>

          <div class="row" v-if="hasMoreUsers(group.id)">
            <div class="col-12 col-sm-5 mx-auto">
              <button
                  @click="fetchMoreStaffs(group.id, true)"
                  type="button"
                  class="wfh-btn-color-primary wfh-btn-large btn-block"
              >
                See More
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12" v-if="users.length == 0 && !groupLoading && !isFiltering">
        <div class="row mb-4">
            <div class="col-12 text-center">
              No freelancers with the filtered value found
            </div>
          </div>
      </div>

      <div v-if="(singleLoading || groupLoading) && !fetchMore" class="d-block position-relative">
        <p class="d-flex">
          <span class="spinner-border mr-2" role="status">
            <span class="sr-only">Loading...</span>
          </span>
          Loading staffs data...
        </p>
      </div>

    </div>

  </div>
</template>

<script>
import FilterIcon from '@icons/FilterIcon';
import { debounce } from 'lodash';
import { mapState } from 'vuex';
import Multiselect from "vue-multiselect";

export default {
  props: {
    status: {
      required: false,
      default: '',
    },
  },

  components: { FilterIcon, Multiselect},

  data () {
    return {
      startDate: null,
      endDate: null,
      reset: false,
      users: [],
      // normal list pagination control
      singleLoading : false,
      singleTotalPages : 1,
      singleCurrentPage : 1,

      // department list pagination control
      departments: [],
      loading: {},
      currentPage: [],
      totalPages: [],
      mode : 'list',
      isFiltering : false,
      fetchMore : false,

      //filters
      searchQuery: null,
      userType: 'freelancer',
      userGroupFilter : [],
      userGroupFilterId : []

    };
  },

  computed: {
    ...mapState(['currentUser', 'companyTeams']),

    userGroupOptions () {
      return this.companyTeams.map(c => {
        return {
          label: c.name,
          code: c.id,
        }
      })
    },

    groupLoading () {
      return Object.values(this.loading).some(check => check)
    }
  },

  watch: {
    currentUser () {
      this.setDateRange().then(() => {
        this.debouncedFetch();
      });
    },
  },

  methods: {

    preset() {
      this.reset = true;
      this.currentPage = []
      this.totalPages = []
      this.singleCurrentPage = 1
      this.singleTotalPages = 1
      this.users = []
      this.loading = {}
    },

    applyFilter() {
      this.preset()
      this.isFiltering = true
      this.debouncedFetch();
      if(this.userGroupFilter.length > 0){
        this.mode = 'department'
      }else {
        this.mode = 'list'
      }

      jQuery("#searchFilter").modal("hide");
    },

    resetFilter() {
      this.preset()
      this.searchQuery = null
      this.userGroupFilter = []
      this.userGroupFilterId = []
      this.debouncedFetch()
      this.mode = 'list'

      jQuery("#searchFilter").modal("hide")
    },

    setUserGroup(value) {
      if(value){
        this.userGroupFilter = [value]
      }else{
        this.userGroupFilter = []
      }
    },

    hasRelatedUsers(group) {
      const relatedCheck = group.members.some(member => this.isRelatedMember(member))
      const groupCheck = this.userGroupFilterId.includes(group.id);

      return relatedCheck && groupCheck;
    },

    isRelatedMember(member) {
      return this.users.map(u => u.raw_id).includes(member.id);
    },

    getRelatedMember(group) {
      return group.members.filter(
        member => this.isRelatedMember(member)
      ).map(
        member => {
          return this.users.find(user => user.raw_id == member.id)
        }
      )
    },

    debouncedFetch: debounce(function () {
      if(this.mode == 'department'){
        this.userGroupFilterId = this.userGroupFilter?.map(a=>a.code)

        this.companyTeams.forEach(d=>{
          this.$set(this.loading, d.id, false)

          if(this.userGroupFilterId.length == 0 ){
            this.fetchTeamMembers(d.id)
          }else{
            if(this.userGroupFilterId.includes(d.id)){
              this.fetchTeamMembers(d.id)
            }
          }

        })
      }else{
        this.fetchTeamMembers();
      }

    }, 400),

    fetchMoreStaffs (groupId = null, fetchMore = false) {
      this.fetchMore = fetchMore;
      if(groupId){
        this.currentPage[groupId]++;
        this.fetchTeamMembers(groupId);
      }else{
        this.singleCurrentPage++;
        this.fetchTeamMembers();
      }
    },

    async fetchTeamMembers (groupId = null) {
      let page

      if(groupId){
        this.currentPage[groupId] = this.currentPage[groupId] ?? 1
        this.$set(this.loading,groupId,true)

        page = this.currentPage[groupId]
      }else{
        this.singleLoading = true
        page = this.singleCurrentPage ?? 1
      }

      const params = {
        page: page,
        role: this.userType,
        status: 'active',
        start_date: this.startDate,
        end_date: this.endDate,
        group_ids : groupId ?? '',
        type: 'freelancer_report'
      };

      if (this.searchQuery !== null) {
        params['q'] = this.searchQuery;
      }

      const response = await axios.get('/team-members', { params });

      let users = response.data.data.map((user) => {
        const type = user.role_type === 'pick-up-task' ? 'Pick-Up Task' : 'Hourly Timesheet';

        return {
          id: user.id_hash,
          raw_id: user.id,
          name: user.name,
          avatar: user.avatar_src,
          subDescription: `${user.role_name}, ${type}`,
          compliance: '13/13',
          detailsUrl: route('admin.finance-report.staff-details', [user.id_hash]),
          currency: user.payment_currency
        }
      });

      if (users.length > 0) {
        users = await this.fetchUserTasksSummary(users, groupId).then(users => users);
      }

      if (this.reset === true) {
        this.users = users;
      } else {
        this.users = [
          ...this.users,
          ...users,
        ];
      }

      if(groupId){
        this.totalPages[groupId] = response.data.last_page;
        this.$set(this.loading, groupId, false);
      }else{
        this.singleTotalPages = response.data.last_page;
        this.singleLoading = false;
      }

      this.isFiltering = false;
      this.reset = false;
      this.fetchMore = false;
    },

    async fetchUserTasksSummary (users, groupId) {
      const userIds = users.map((user) => user.raw_id);
      const params = {
        user_ids: userIds,
        start_date: this.startDate,
        end_date: this.endDate,
        company_ids: [this.currentUser.company.id],
        group_id: groupId
      };
      const res = await axios.get(route('reports.tasks.summary'), { params });

      users = users.map((user) => {
        return {
          ...user,
          totalCost: res.data.data[user.raw_id] ? res.data.data[user.raw_id]['total_client_cost'] : 0,
          totalTime: res.data.data[user.raw_id] ? res.data.data[user.raw_id]['total_task_minutes'] : 0,
        };
      });

      const departmentSummary = res.data.summary;

      if (this.departments.length === 0 || this.reset) {
        this.departments = this.companyTeams.map((department) => {
          return {
            ...department,
            departmentCosts: department.id === groupId ? (departmentSummary[groupId] ?? []) : (department.departmentCosts ?? [])
          }
        });
      } else {
        const departments = [];

        for (const department of this.departments) {
          if (department.departmentCosts.length !== 0) {
            departments.push(department);
            continue;
          }

          departments.push({
            ...department,
            departmentCosts: department.id === groupId ? (departmentSummary[groupId] ?? []) : (department.departmentCosts ?? [])
          });
        }

        this.departments = departments;
      }

      return users;
    },

    async setDateRange () {
      this.startDate = localStorage.getItem('wfh_adm_sd') ?? moment().startOf('month').format('YYYY-MM-DD');
      this.endDate = localStorage.getItem('wfh_adm_ed') ?? moment().format('YYYY-MM-DD');
    },

    hasMoreUsers (groupId = null) {
      if(groupId){
        return this.loading[`${groupId}`] === false && this.currentPage[groupId] < this.totalPages[groupId];
      }
      return this.singleLoading === false && this.singleCurrentPage < this.singleTotalPages;
    },

    getLoading (groupId) {
      return this.loading[groupId];
    }
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
  @import "../../../../../sass/core/mixins";

  .search-filter {
    .icon-filter {
      color: #303030;
      font-family: "Open Sans";
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 0;
      line-height: 22px;
    }

    .link-filter {
      color: #303030;
      font-family: "Open Sans";
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 0;
      line-height: 22px;

      @media (max-width: 768px) {
        font-size: 14px;
      }
    }

    .modal-name {
      color: #303030;
      font-family: Lato;
      font-size: 20px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 28px;
    }

    .btn-cancel {
      color: #0db4e6;
      font-family: "Open Sans";
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 0;
      line-height: 22px;
    }

    .btn-filter {
      height: 56px;
      background-color: #000000;
      width: 100%;
      color: #ffffff;
      font-family: "Open Sans";
      font-size: 14px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 22px;
      text-align: center;
      border-radius: 4px;
    }

    .btn-clear {
      height: 56px;
      width: 100%;
      color: #28282e;
      font-family: "Open Sans";
      font-size: 14px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 22px;
      text-align: center;
      border: 1px solid #28282e;
      border-radius: 4px;
    }
  }

  $color-accent: #5145ff;

  .text-accent {
    color: $color-accent;
  }

  .bg-accent {
    background-color: $color-accent;
  }

  @include media-breakpoint-down(sm) {
    .modal-dialog {
      margin: 0;
      bottom: 0;
      position: absolute;
      left: 0;
      right: 0;
      max-width: 100%;
    }
  }
</style>

<style>
  .multiselect__placeholder{
    padding-left: 10px;
  }

  .currency-grid {
    text-align: center;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-auto-rows: min-content;
    grid-gap: 0.5rem;
  }

  .currency-tag {
    background-color: #eee;
    padding: 0.25rem 0.5rem;
    display: inline-block;
  }

</style>
